module.exports = __webpack_public_path__ + "static/img/h5.cae11ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/multidaytours/tour3/h5.jpg
// module id = Z5+3
// module chunks = 0